import Box from '@mui/joy/Box'
import Sheet from '@mui/joy/Sheet'
import Table from '@mui/joy/Table'
import { CampaignRow } from './CampaignRow'

export const CampaignsTable = ({ campaigns, onItemClick, onItemDelete }) => {
    return (
        <Sheet>
            <Table variant="outlined" hoverRow>
                <thead>
                    <tr>
                        <th style={{ width: '50%' }}>Title</th>
                        <th>Type</th>
                        <th>Created</th>
                        <th>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                Action
                            </Box>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {campaigns.map((campaign) => (
                        <CampaignRow
                            key={campaign.id.toString()}
                            campaign={campaign}
                            onClick={onItemClick}
                            onDelete={onItemDelete}
                        />
                    ))}
                </tbody>
            </Table>
        </Sheet>
    )
}
